import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

import { Close, Fail } from '../Icons';
import * as Modal from '../styles';
import { responsive } from 'theme/constants';
import { useModal } from 'context/modal/ModalContext';
import { ErrorDisplay } from 'components/ErrorDisplay';
import { useExchange } from 'context/exchange/ExchangeContext';

const FailIconWrapper = styled(Modal.ModalIconWrapper)`
  background-color: ${props => props.theme.colors.highlightRed};
  border-color: #412a33;

  svg * {
    fill: ${props => props.theme.colors.textPrimary};
  }
`;

const FooterControls = styled(Modal.FooterControls)`
  justify-content: center;
`;

const Message = styled.div`
  max-height: 320px;
  padding: 32px;
  margin: 32px 0 24px;

  background-color: ${props => props.theme.colors.bgDarken};
  border-radius: 8px;

  color: ${props => props.theme.colors.textSecondary};
  text-align: center;
  word-break: break-all;

  overflow-y: scroll;

  @media screen and (max-width: ${responsive.laptop}) {
    padding: 24px;
    margin: 24px 0 20px;
  }

  @media screen and (max-width: ${responsive.smartphone}) {
    font-size: 14px;
  }
`;

export default function TransactionFailedModal({
  error,
  header = 'Transaction Failed',
  disableClose = false,
}: {
  error: any;
  header?: string;
  disableClose?: boolean;
}) {
  const { handleModal = null } = useModal() || {};

  const { resetAll } = useExchange();
  const navigate = useNavigate();

  useEffect(() => {
    return () => {
      resetAll();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function doClose() {
    if (disableClose) return window.location.reload();
    handleModal();
    navigate('/');
  }

  return (
    <Modal.Wrapper>
      {!disableClose && (
        <Modal.CloseIcon onClick={() => doClose()} data-testid="failed-modal-close-icon">
          <Close />
        </Modal.CloseIcon>
      )}

      <main>
        <FailIconWrapper>
          <Fail />
        </FailIconWrapper>
        <Modal.Caption>{header}</Modal.Caption>

        <Message>
          <ErrorDisplay error={error} />
        </Message>
      </main>
      {!disableClose && (
        <footer>
          <FooterControls>
            <Modal.PrimaryButton
              onClick={() => doClose()}
              data-testid="failed-modal-primary-button"
            >
              Ok &#x1f625;
            </Modal.PrimaryButton>
          </FooterControls>
        </footer>
      )}
    </Modal.Wrapper>
  );
}
